"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectInlinePreviewsOption')(function selectInlinePreviewsOption(isInlinePreviewsEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isInlinePreviewsEnabled;
}));
//# sourceMappingURL=selectInlinePreviewsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/actions/selectInlinePreviewsOption.js
// module id = 5095
// module chunks = 2